import { MODELS, MODELS_EARNINGS } from "../types";

export const modelsEarningsReducer = (state = [], action) => {
	const { type, payload } = action;

	switch (type) {
		case MODELS_EARNINGS: {
			const { data } = payload;
			state = [];
			return [...state, ...data];
		}

		default: {
			return state;
		}
	}
};
